export default __webpack_public_path__ + "static/media/mountains.295f5cf8.jpg";